// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-9546505c] {\n  padding: 5px;\n  border-radius: 5px;\n  color: white;\n}\n.active[data-v-9546505c] {\n  background: #72bf44;\n  box-shadow: none;\n}\n.jailed[data-v-9546505c] {\n  background: #ff5151;\n  box-shadow: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
